<router-outlet></router-outlet>
<mat-divider></mat-divider>
<div class="inner-all mat-typography" style="display: flex; align-items: center">
    <div style="flex: 1"></div>
    <div class="cp-text-small cp-text-muted cp-text-strong">&copy; IPB {{date | date:'yyyy'}} :: {{version}}</div>
</div>